import { render } from "./verifiedSecondary.vue?vue&type=template&id=11b8a71b"
import script from "./verifiedSecondary.vue?vue&type=script&lang=js"
export * from "./verifiedSecondary.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__